import React from "react";
import { CircularProgress, Container } from "@material-ui/core";

export default () => (
    <Container>
        <CircularProgress />
    </Container>
);
